import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCta() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="py-12" data-id="element-42">
      <div className="bg-brand-card border border-brand-orange/20 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden shadow-glow" data-id="element-43">
        <div className="absolute -top-20 -left-20 w-48 h-48 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-44" />
        <div className="absolute -bottom-20 -right-20 w-48 h-48 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-45" />

        <div className="relative z-10" data-id="element-46">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-47">
            Still have questions? Or are you ready to meet your new favorite
            desk companion?
          </h2>
          <p className="text-brand-muted text-lg mb-8 max-w-lg mx-auto" data-id="element-48">
            Don't let your workspace stay in the dark. Join thousands of
            creators and students who have upgraded their setup.
          </p>
          <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} onClick={() => document.getElementById('bundles')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full sm:w-auto px-10 py-5 bg-brand-orange text-white text-lg md:text-xl font-bold rounded-xl shadow-glow hover:shadow-glow-hover transition-all duration-300 inline-flex items-center justify-center gap-3" data-id="element-49">
            GET MY LUMIMATE NOW - 40% OFF
            <ArrowRightIcon className="w-6 h-6" data-id="element-50" />
          </motion.button>
        </div>
      </div>
    </motion.section>;
}